// Decode the payload segment of a JWT WITHOUT verifying its signature.
//
// Claims-read only: the hardware-viewer backend (smartdeviceplatformagg BFF's
// XHeaderSessionAuthenticationHandler) validates the session against the shared
// Redis store on every request, so the frontend never needs to verify the token.
// We only need three claims out of the login JWT (issued by admin-portal-backend's
// getToken): SessionId, sub, email. These map 1:1 to the XSessionId / XUserId /
// XUserEmail headers the BFF expects. (No jwt-decode dependency by design.)
export function decodeJwtClaims(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    // base64url -> base64, then pad to a multiple of 4.
    let payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    while (payload.length % 4) payload += "=";
    // atob -> UTF-8-safe string -> JSON.
    const json = decodeURIComponent(
      atob(payload)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}
